/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import firebase from 'firebase/compat/app';
import { Injectable } from '@angular/core';
import { SnapshotAction } from '@angular/fire/compat/database';
import { TicketFields } from '@touchplan/common';
import { takeUntil } from 'rxjs/operators';
import { ITicketIndexData } from './ticket-index-data';
import { TicketIndexQuery } from './ticket-index-query';

/**
 */
@Injectable({
	providedIn: 'root',
})
export class TicketIndexLogger {
	// BAH
	// Primitive boolean flag...  Where's dose Bunyan and Winston deals when you need 'em...
	public loggingEnabled = false;

	constructor() {}

	public logTicketIndexQueryOutput(ticketIndexQuery: TicketIndexQuery, logWindow: boolean) {
		ticketIndexQuery.ticketSnapshotChange$.pipe(takeUntil(ticketIndexQuery.stopSnapshot$)).subscribe((x) => {
			const ticket = x.payload.val();
			console.log(
				'%c ==> ',
				'background: #000000; color: #FFFFFF',
				x.type,
				"('" + ticket.activityName + "')",
				'window length: ' + ticketIndexQuery.getLatestWindowLength()
			);
			if (logWindow) {
				console.log(
					'%c         window: ',
					'background: #AAAAAA',
					ticketIndexQuery
						.getLatestWindow()
						.map((elem) =>
							elem.subscribed ? elem.ticketFields.activityName : 'un[' + elem.ticketFields.activityName + ']'
						)
				);
			}
		});
	}

	public logIndexStateChangeSubscribe(indexRef: firebase.database.Reference) {
		if (this.loggingEnabled) {
			console.log('index subscribe: ref = ' + indexRef.toString());
		}
	}

	public logIndexStateChange(sa: SnapshotAction<ITicketIndexData>): void {
		if (this.loggingEnabled) {
			this.logSnapshotChange(sa, 'index', 'background: #F4F488');
		}
	}

	public logTicketSnapshotChangeSubscribe(ref: firebase.database.Reference) {
		if (this.loggingEnabled) {
			console.log('%c ######## ticket subscribe: ref = ' + ref.toString(), 'background: #FFCCCC');
		}
	}

	public logTicketSnapshotChangeUnsubscribe(ticketId: string) {
		if (this.loggingEnabled) {
			console.log(
				'%c **** UNSUBSCRIBE **** : snapshotChanges for ticket: ' + ticketId,
				'background: #444444; color: #FFFFFF'
			);
		}
	}

	public logDoctorSnapshotCall(
		indexSnapshot: SnapshotAction<ITicketIndexData>,
		ticketSnapshot: SnapshotAction<TicketFields>,
		ticketChangeCount: number
	) {
		if (this.loggingEnabled) {
			const style = 'background: #FFFFFF';
			const valueStyle = 'background: #FFAAAA';
			const types = indexSnapshot.type + '/' + ticketSnapshot.type;
			console.log(
				'%c ======== doctorSnapshot    change: { types: %c ' +
					types +
					', %c index count: %c ' +
					ticketChangeCount +
					' %c }',
				style,
				valueStyle,
				style,
				valueStyle,
				style
			);
		}
	}

	public logTicketSnapshotChange(sa: SnapshotAction<TicketFields>, bgColor?: string): void {
		if (this.loggingEnabled) {
			this.logSnapshotChange(sa, 'ticket (RAW)     ', 'background: ' + (bgColor ? bgColor : '#FFDDBB'));
		}
	}

	public logTicketSnapshotNoPayload() {
		if (this.loggingEnabled) {
			console.log(
				'%c #### NO PAYLOAD on ticket snapshot change:  means ticket was deleted and not just moved out of query range ####',
				'background: #DDDDAA; color: #BB0000'
			);
		}
	}

	public logDoctoredTicketSnapshotChange(sa: SnapshotAction<TicketFields>): void {
		if (this.loggingEnabled) {
			this.logSnapshotChange(sa, 'ticket (DOCTORED)', 'background: #FFCCFF');
		}
	}

	public logSnapshotChange(sa: SnapshotAction<any>, prefix: string, style: string): void {
		if (this.loggingEnabled) {
			let typeStyle = style;
			switch (sa.type) {
				case 'child_added':
					typeStyle = 'background: #AAFFFF';
					break;
				case 'child_moved':
					typeStyle = 'background: #BBFFBB';
					break;
				case 'child_changed':
					typeStyle = 'background: #CCCCCC';
					break;
				case 'child_removed':
					typeStyle = 'background: #FFAAAA';
					break;
			}
			console.log(
				'%c ===== ' +
					prefix +
					' change: { type: %c ' +
					sa.type +
					" %c prevKey: '" +
					sa.prevKey +
					"', key: '" +
					sa.key +
					"' }",
				style,
				typeStyle,
				style,
				sa.payload.val()
			);
		}
	}
}
